document.addEventListener('DOMContentLoaded', function () {
  const observerTarget = document.querySelector('#searchspring-content') || document.body

  if (!observerTarget) {
    console.error('[Quick View] Unable to find a container to observe for quick view buttons.')
    return
  }

  // Function to handle Quick View button clicks
  function handleQuickViewClick(event) {
    const productHandle = event.currentTarget.dataset.handle
    const ssResult = event.currentTarget.closest('.ss__result__inner')
    const variant = ssResult?.querySelector('.ss__palette__option--active')?.dataset?.variantId
    const url = variant ? `/products/${productHandle}?view=quickview&variant=${variant}` : `/products/${productHandle}?view=quickview`

    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const modal = document.getElementById('custom-modal')
        const modalBody = modal.querySelector('#modal-body-content')

        if (modal && modalBody) {
          modalBody.innerHTML = responseText // Set the fetched content
          showModal(modal) // Show the modal

          // Wait a bit for DOM to be ready, then init gallery swiper
          setTimeout(() => {
            if (typeof _lspace !== 'undefined' && _lspace.swiper && _lspace.swiper.init) {
              _lspace.swiper.init('quickview')

              let qvSizeTries = 0
              const ensureQvSwiperSized = function () {
                qvSizeTries++
                const qvModalEl = document.getElementById('quick-view')
                if (qvModalEl) {
                  const galleryEl = qvModalEl.querySelector('.gallery-top')
                  if (galleryEl && galleryEl.swiper && typeof galleryEl.swiper.update === 'function') {
                    galleryEl.swiper.update()
                  }
                  const thumbsEl = qvModalEl.querySelector('.thumbs-container')
                  if (thumbsEl && thumbsEl.swiper && typeof thumbsEl.swiper.update === 'function') {
                    thumbsEl.swiper.update()
                  }
                }
                if (qvSizeTries < 12) {
                  setTimeout(ensureQvSwiperSized, 80)
                }
              }
              setTimeout(ensureQvSwiperSized, 80)
            }
          }, 50)

          window.quickViewProductHandle = productHandle
          window.quickViewVariantId = variant || null

          // Dispatch quickview:loaded FIRST to let linked products render
          document.dispatchEvent(new CustomEvent('quickview:loaded'))

          // Wait for linked products to render and update product-js data, then initialize product data
          // Increased timeout to ensure linked products fully render and update product data
          setTimeout(() => {
            setupData(url) // Initialize product data and variant selection
          }, 300)

          // Init Yotpo
          if (typeof Yotpo !== 'undefined') {
            const api = new Yotpo.API(yotpo)
            api.refreshWidgets()
          }

          // Color selection is now handled by linked-products.js using window.quickViewProductHandle
        } else {
          console.error('Modal element or modal body not found.')
        }
      })
      .catch((error) => console.error('Failed to fetch quick view content', error))
  }

  // Function to show the modal
  function showModal(modal) {
    modal.classList.add('show')
    document.body.style.overflow = 'hidden'

    // Attach close functionality to the close button
    const closeButton = modal.querySelector('[data-close-modal]')
    if (closeButton) {
      closeButton.addEventListener('click', () => hideModal(modal), { once: true })
    }
  }

  // Function to hide the modal
  function hideModal(modal) {
    modal.classList.remove('show')
    document.body.style.overflow = ''

    // Restore original PDP swipers if they were stored
    if (typeof _lspace !== 'undefined' && _lspace.swiper && _lspace.swiper.restorePDPSwipers) {
      _lspace.swiper.restorePDPSwipers()
    }
  }

  // Close modal when clicking outside the content or pressing Escape
  document.addEventListener('click', (event) => {
    const modal = document.getElementById('custom-modal')
    if (modal && event.target === modal) {
      hideModal(modal)
    }
  })

  document.addEventListener('keydown', (event) => {
    const modal = document.getElementById('custom-modal')
    if (event.key === 'Escape' && modal && modal.classList.contains('show')) {
      hideModal(modal)
    }
  })

  // Function to attach click event to Quick View buttons
  function attachQuickViewEvents() {
    const quickViewButtons = document.querySelectorAll('.quick-view')
    quickViewButtons.forEach((button) => {
      if (!button.hasAttribute('data-event-bound')) {
        // Avoid binding multiple times
        button.setAttribute('data-event-bound', 'true')
        button.addEventListener('click', handleQuickViewClick)
      }
    })
  }

  // Initial binding on page load
  attachQuickViewEvents()

  // Initialize MutationObserver to watch for dynamically added Quick View buttons
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        attachQuickViewEvents() // Attach events when new nodes are added
      }
    })
  })

  // Start observing the wrapper for any child additions
  observer.observe(observerTarget, { childList: true, subtree: true })
})

// Store productData globally so it can be updated
let quickViewProductData = null

function setupData(url, productDataOverride = null) {
  // Find the script tag - it could be in the modal body or in #quick-view
  const modalBody = document.querySelector('#modal-body-content')
  const quickViewModal = document.querySelector('#quick-view')
  const scope = quickViewModal || modalBody || document
  const scriptTag =
    scope.querySelector('script[type="application/json"][data-product-js]') ||
    document.querySelector('script[type="application/json"][data-product-js]')
  if (!scriptTag) {
    console.error('Quick view: Could not find product-js script tag')
    return
  }

  // Use provided product data or parse from script tag
  const productData = productDataOverride || JSON.parse(scriptTag.textContent)
  if (!quickViewProductData || productDataOverride) {
    quickViewProductData = productData
  }
  const pData = {
    actions: {
      // Utility function to find the first in-stock variant
      findFirstInStockVariant: function () {
        // Check URL parameter first
        const urlParams = new URLSearchParams(url.split('?')[1] || '')
        const urlVariantId = urlParams.get('variant')

        if (urlVariantId) {
          // If URL has a variant, check if it's in stock
          if (productData.config.availability.hasOwnProperty(urlVariantId) && productData.config.availability[urlVariantId]) {
            return urlVariantId
          }

          // URL variant is out of stock — find first in-stock variant of the same color
          const urlVariant = productData.config.product.variants.find(v => String(v.id) === String(urlVariantId))
          if (urlVariant) {
            const sameColorInStock = productData.config.product.variants.find(v =>
              v.option1 === urlVariant.option1 &&
              productData.config.availability.hasOwnProperty(v.id) &&
              productData.config.availability[v.id]
            )
            if (sameColorInStock) return sameColorInStock.id
          }
        }

        // Find first in-stock variant
        for (let i = 0; i < productData.config.product.variants.length; i++) {
          const variant = productData.config.product.variants[i]
          if (productData.config.availability.hasOwnProperty(variant.id) && productData.config.availability[variant.id]) {
            return variant.id
          }
        }

        // If no in-stock variants found, fall back to first variant
        return productData.config.product.variants[0].id
      },
      selectVariant: function (id) {
        const quickViewModal = document.querySelector('#quick-view')
        const scope = quickViewModal || document
        const selectInput = scope.querySelector('select[name=id]')
        if (selectInput) selectInput.value = id

        if (typeof _lspace !== 'undefined' && _lspace.swiper) {
          _lspace.swiper.constrain(id)
        }

        const discountInput = scope.querySelector('input#discount')
        const variantDiscount = productData?.config?.variant_discounts?.[id]?.amount
        if (discountInput && variantDiscount) {
          discountInput.setAttribute('name', 'properties[discount_amount]')
          discountInput.value = 100 - variantDiscount
        } else if (discountInput) {
          discountInput.setAttribute('name', 'ignore')
          discountInput.value = ''
        }

        const afterpayElement = scope.querySelector('.afterpay-paragraph')
        const variants = productData?.config?.product?.variants || []

        variants.forEach((variant) => {
          if (variant.id === id) {
            const metaImg = document.querySelector("meta[property='og:image']")
            if (metaImg && variant?.featured_image?.src) {
              metaImg.content = variant.featured_image.src
            }

            updateActiveOptions(variant, scope)

            if (productData?.config?.availability?.[variant.id]) {
              if (afterpayElement) afterpayElement.style.display = 'block'
              const addToCart = scope.querySelector('#addtocart')
              if (addToCart) {
                addToCart.removeAttribute('disabled')
                addToCart.textContent = 'Add to Bag'
              }
            } else {
              if (afterpayElement) afterpayElement.style.display = 'none'
              const addToCart = scope.querySelector('#addtocart')
              if (addToCart) {
                addToCart.setAttribute('disabled', 'disabled')
                addToCart.textContent = 'Out of Stock'
              }
            }

            updateProductPrice(variant, scope)

            if (window.recomputeATCState) {
              window.recomputeATCState(scope)

              requestAnimationFrame(() => {
                window.recomputeATCState(scope)
              })
            }
          }
        })
      },
      selectOption: function (option, value, selectedOptions = {}, memory = {}) {
        const currentSelection = { ...selectedOptions }
        currentSelection[option] = value

        const qvModal = document.querySelector('#quick-view')
        const qvScope = qvModal || document
        qvScope.querySelectorAll(`li[data-option-index="${option}"]`).forEach((el) => {
          el.classList.remove('active')
          el.classList.add('not-active')
          const navLink = el.querySelector('.nav-link')
          if (navLink) {
            navLink.classList.remove('active')
            navLink.classList.add('not-active')
          }
        })
        qvScope.querySelectorAll(`li[data-option-index="${option}"][data-value="${value}"]`).forEach((el) => {
          el.classList.remove('not-active')
          el.classList.add('active')
          const navLink = el.querySelector('.nav-link')
          if (navLink) {
            navLink.classList.remove('not-active')
            navLink.classList.add('active')
          }
        })

        let updatedMemory = memory

        // Creates memory if it doesn't exist - Memory is used to reduce lookup times by using this as a cache to see, which products are sold out or not.
        if (updatedMemory === undefined) {
          updatedMemory = {}

          // iterate all variants
          productData.config.product.variants.forEach(function (variant) {
            // Any available options goes in here
            let options = []
            // Check options available
            if (variant.option1) {
              options.push(variant.option1)
            }
            if (variant.option2) {
              options.push(variant.option2)
            }
            if (variant.option3) {
              options.push(variant.option3)
            }

            // Remove spaces from option names such as Midnight Blue => MidnightBlue
            options = options.map(function (option) {
              return option.split(' ').join('')
            })

            // create key to use as memory key e.g. classicWhiteSmall
            const key = options.join('')

            // Set to wheter variant is available or not for quick lookup
            updatedMemory[key] = {
              availability: variant.available,
              id: variant.id // TODO: Does it error here?
            }
          })
        }

        // For linked products, handle size and coverage options - color is handled by linked-products.js
        // We check for data-linked-product (from liquid) OR data-linked-product-container (which linked-products.js uses)
        const isLinkedProductInSelect =
          qvScope.querySelector('[data-linked-product]') !== null ||
          qvScope.querySelector('[data-linked-product-container]') !== null ||
          qvScope.querySelector('#linked-products-json') !== null

        // Grab all option elements - for linked products size + coverage, for others all non-color options
        // Exclude color swatches in linked-product-container (those are managed by linked-products.js)
        let optionElements
        if (isLinkedProductInSelect) {
          optionElements = qvScope.querySelectorAll('[data-product-size] li[data-product-option], [data-option="Coverage"] li[data-product-option]')
        } else {
          optionElements = qvScope.querySelectorAll(
            '[data-product-size] li[data-product-option], [data-option="Coverage"] li[data-product-option], .nav:not([data-linked-product-container]) li[data-product-option]'
          )
        }

        // Get current selected options without whitespace
        let selectedOptionOne = ''
        let selectedOptionTwo = ''
        let selectedOptionThree = ''
        let SelectedOptionKey = ''

        // Set the selected options based on which options the user clicked.
        if (currentSelection['1']) {
          selectedOptionOne = currentSelection['1'].split(' ').join('')
        }
        if (currentSelection['2']) {
          selectedOptionTwo = currentSelection['2'].split(' ').join('')
        }
        if (currentSelection['3']) {
          selectedOptionThree = currentSelection['3'].split(' ').join('')
        }

        // Create key in order to access the user's selected variant in memory.
        SelectedOptionKey = selectedOptionOne + (selectedOptionTwo || '') + (selectedOptionThree || '')

        // Iterate over all option dom elements and check against memory
        optionElements.forEach(function (optionEl) {
          // create key to use for memory lookup
          let key = ''
          // The index and value of the dom element (lives in data-option-index and data-value on the element)
          const optionIndex = optionEl.dataset.optionIndex
          const optionValue = optionEl.dataset.value

          // Making sure the current options doesn't contain whitespaces
          const currentOption = optionValue.split(' ').join('')
          // if user clicked an option in index 1
          if (optionIndex === '1') {
            // create key for memory lookup to check for variant availability
            key += currentOption + (selectedOptionTwo || '') + (selectedOptionThree || '')
          } else if (optionIndex === '2') {
            // create key for memory lookup to check for variant availability
            key += selectedOptionOne + currentOption + (selectedOptionThree || '')
          } else if (optionIndex === '3') {
            // create key for memory lookup to check for variant availability
            key += selectedOptionOne + selectedOptionTwo + currentOption
          }

          // Disable or remove disabled class based on variant availability
          let oos_label = 'OUT OF STOCK'
          const navLink = optionEl.querySelector('.nav-link')
          if (!updatedMemory[key] || updatedMemory[key].availability === false) {
            optionEl.classList.add('disabled')
            if (navLink) {
              navLink.classList.add('disabled')
              navLink.classList.remove('not-disabled')
            }
            // ADA: add out of stock label
            if (optionEl.ariaLabel && optionEl.ariaLabel.indexOf(oos_label) === -1) {
              optionEl.ariaLabel = oos_label + ' ' + optionEl.ariaLabel
            }
          } else {
            optionEl.classList.remove('disabled')
            if (navLink) {
              navLink.classList.remove('disabled')
              navLink.classList.add('not-disabled')
            }
            // ADA: rm out of stock label
            if (optionEl.ariaLabel && optionEl.ariaLabel.indexOf(oos_label) > -1) optionEl.ariaLabel = optionEl.ariaLabel.replace(oos_label, '')
          }
        })

        const selectedKey = getSelectedKey(currentSelection)
        const selectedVariantId = updatedMemory[selectedKey]?.id

        if (selectedVariantId) {
          pData.actions.selectVariant(selectedVariantId)
        } else {
          // If we can't find a variant by the selected key, try to find the first available variant
          // that matches the current selection (partial match)
          let fallbackVariant = null
          if (productData?.config?.product?.variants) {
            for (const variant of productData.config.product.variants) {
              const variantKey = [variant.option1 || '', variant.option2 || '', variant.option3 || ''].filter(Boolean).join('').replace(/\s/g, '')

              // Check if this variant matches the current selection
              let matches = true
              if (currentSelection['1'] && variant.option1) {
                matches = matches && variant.option1.replace(/\s/g, '') === currentSelection['1'].replace(/\s/g, '')
              }
              if (currentSelection['2'] && variant.option2) {
                matches = matches && variant.option2.replace(/\s/g, '') === currentSelection['2'].replace(/\s/g, '')
              }
              if (currentSelection['3'] && variant.option3) {
                matches = matches && variant.option3.replace(/\s/g, '') === currentSelection['3'].replace(/\s/g, '')
              }

              if (matches && variant.available) {
                fallbackVariant = variant
                break
              }
            }
          }

          if (fallbackVariant) {
            pData.actions.selectVariant(fallbackVariant.id)
          } else {
            const addToCart = qvScope.querySelector('#addtocart')
            if (addToCart) {
              addToCart.setAttribute('disabled', 'disabled')
              addToCart.textContent = 'Unavailable'
            }
          }
        }

        setTimeout(() => document.dispatchEvent(new Event('product:OptionSelected')), 200)

        return { selectedOptions: currentSelection, memory: updatedMemory }
      },
      showAvailableColors: function () {
        const qvModalForColors = document.querySelector('#quick-view')
        const qvScopeForColors = qvModalForColors || document
        const selectedCoverageElement = qvScopeForColors.querySelector('div[data-option="Coverage"] .nav-item.active span')
        const selectedCoverage = selectedCoverageElement?.textContent?.trim()
        if (selectedCoverage) {
          const coverageColors = productData?.config?.product?.variants
            ?.filter((variant) => variant.option1 === selectedCoverage)
            .map((variant) => variant.option2.toLowerCase())

          const availableColors = [...new Set(coverageColors)]

          qvScopeForColors.querySelectorAll('li[data-option-index="2"]').forEach((color) => {
            const currentColor = color.dataset?.value?.trim().toLowerCase()
            if (!availableColors.includes(currentColor)) {
              color.classList.add('not-available')
            } else {
              color.classList.remove('not-available')
            }
          })
        }
      }
    },
    init: function () {
      if (productData.config.child && productData.config.child.variants)
        productData.config.product.variants = productData.config.product.variants.concat(productData.config.child.variants)

      // Select the first in-stock variant or URL variant if available
      const selectedVariantId = pData.actions.findFirstInStockVariant()
      if (selectedVariantId) {
        pData.actions.selectVariant(selectedVariantId)
      }
      document.body.addEventListener('click', (event) => {
        if (event.target.matches('div[data-option="Coverage"] .nav-item.active')) {
          pData.actions.showAvailableColors()
        }
      })
      pData.actions.showAvailableColors()

      // add event listeners
      function addOptionClickListeners() {
        const quickViewModal = document.querySelector('#quick-view')
        const scope = quickViewModal || document

        // Check if this is a linked product - if so, linked-products.js handles color options
        // We check for data-linked-product (from liquid) OR data-linked-product-container (which linked-products.js uses) OR the json data
        const isLinkedProductForClickHandlers =
          scope.querySelector('[data-linked-product]') !== null ||
          scope.querySelector('[data-linked-product-container]') !== null ||
          scope.querySelector('#linked-products-json') !== null

        // For linked products: handle size and coverage options (linked-products.js handles color)
        // For non-linked products: handle all options except those in linked-product-container
        // Never select color swatches in linked-product-container (those are always managed by linked-products.js)
        let clickableOptions
        if (isLinkedProductForClickHandlers) {
          // For linked products, handle size and coverage options - color is handled by linked-products.js
          clickableOptions = scope.querySelectorAll('[data-product-size] li[data-product-option], [data-option="Coverage"] li[data-product-option]')
        } else {
          // For non-linked products, handle size and coverage options
          clickableOptions = scope.querySelectorAll(
            '[data-product-size] li[data-product-option], [data-option="Coverage"] li[data-product-option], .nav:not([data-linked-product-container]) li[data-product-option]'
          )
        }
        // State will change based on clicked options

        // Select the first in-stock variant or URL variant if available
        const selectedVariantId = pData.actions.findFirstInStockVariant()
        let selectedVariant

        productData.config.product.variants.forEach(function (variant) {
          if (variant.id == selectedVariantId) {
            selectedVariant = variant
          }
        })

        // If we couldn't find the variant by ID, try to find the first in-stock variant
        if (!selectedVariant) {
          for (let i = 0; i < productData.config.product.variants.length; i++) {
            const variant = productData.config.product.variants[i]
            if (productData.config.availability && productData.config.availability[variant.id]) {
              selectedVariant = variant
              break
            }
          }
          // If still no variant, use the first one
          if (!selectedVariant && productData.config.product.variants.length > 0) {
            selectedVariant = productData.config.product.variants[0]
          }
        }

        // find available options from selectedVariant
        let selectedOptions = {}
        let colorSelect

        if (selectedVariant) {
          if (selectedVariant.option1) {
            selectedOptions[1] = selectedVariant.option1
            colorSelect = selectedVariant.option1
          }
          if (selectedVariant.option2) {
            selectedOptions[2] = selectedVariant.option2
          }
          if (selectedVariant.option3) {
            selectedOptions[3] = selectedVariant.option3
            colorSelect = selectedVariant.option2
          }
        }

        // display color based on variant
        const qvModalForInit = document.querySelector('#quick-view')
        const qvScopeForInit = qvModalForInit || document
        let colorDisplay = qvScopeForInit.querySelector('#product-box__option-color') || document.getElementById('product-box__option-color')

        if (colorDisplay) {
          colorDisplay.innerText = colorSelect
        }

        // Build memory store from all variants
        let memory = {}
        productData.config.product.variants.forEach(function (variant) {
          let options = []
          if (variant.option1) options.push(variant.option1)
          if (variant.option2) options.push(variant.option2)
          if (variant.option3) options.push(variant.option3)
          options = options.map(function (option) {
            return option.split(' ').join('')
          })
          const key = options.join('')
          memory[key] = {
            availability: variant.available,
            id: variant.id
          }
        })

        // Manually update option disabled states based on memory without calling selectOption
        // This avoids changing the selected variant during initialization
        // For linked products, handle size and coverage options - color is handled by linked-products.js
        // Exclude color swatches in linked-product-container (those are managed by linked-products.js)
        const isLinkedProductForInit =
          qvScopeForInit.querySelector('[data-linked-product]') !== null ||
          qvScopeForInit.querySelector('[data-linked-product-container]') !== null ||
          qvScopeForInit.querySelector('#linked-products-json') !== null

        let optionElements
        if (isLinkedProductForInit) {
          optionElements = qvScopeForInit.querySelectorAll(
            '[data-product-size] li[data-product-option], [data-option="Coverage"] li[data-product-option]'
          )
        } else {
          optionElements = qvScopeForInit.querySelectorAll(
            '[data-product-size] li[data-product-option], [data-option="Coverage"] li[data-product-option], .nav:not([data-linked-product-container]) li[data-product-option]'
          )
        }
        const selectedOptionOne = (selectedOptions['1'] || '').replace(/\s/g, '')
        const selectedOptionTwo = (selectedOptions['2'] || '').replace(/\s/g, '')
        const selectedOptionThree = (selectedOptions['3'] || '').replace(/\s/g, '')

        optionElements.forEach(function (optionEl) {
          const optionIndex = optionEl.dataset.optionIndex
          const optionValue = (optionEl.dataset.value || '').replace(/\s/g, '')

          // Build key to check against memory
          let key = ''
          if (optionIndex === '1') {
            key = optionValue + selectedOptionTwo + selectedOptionThree
          } else if (optionIndex === '2') {
            key = selectedOptionOne + optionValue + selectedOptionThree
          } else if (optionIndex === '3') {
            key = selectedOptionOne + selectedOptionTwo + optionValue
          }

          const navLink = optionEl.querySelector('.nav-link')
          const oos_label = 'OUT OF STOCK'

          // Check if this option combination exists and is available
          if (!memory[key] || memory[key].availability === false) {
            // This option combination doesn't exist or is unavailable
            optionEl.classList.add('disabled')
            if (navLink) {
              navLink.classList.add('disabled')
              navLink.classList.remove('not-disabled')
            }
            if (optionEl.ariaLabel && optionEl.ariaLabel.indexOf(oos_label) === -1) {
              optionEl.ariaLabel = oos_label + ' ' + optionEl.ariaLabel
            }
          } else {
            // This option combination exists and is available
            optionEl.classList.remove('disabled')
            if (navLink) {
              navLink.classList.remove('disabled')
              navLink.classList.add('not-disabled')
            }
            if (optionEl.ariaLabel && optionEl.ariaLabel.indexOf(oos_label) > -1) {
              optionEl.ariaLabel = optionEl.ariaLabel.replace(oos_label, '').trim()
            }
          }
        })

        // Store selectedOptions and memory for future use
        let initialState = { selectedOptions: selectedOptions, memory: memory }

        // Only apply color sold-out logic to NON-linked products
        // For linked products, each color swatch represents a DIFFERENT product (not a variant)
        // and linked-products.js handles their availability separately
        const isLinkedProduct = qvScopeForInit.querySelector('[data-linked-product]') !== null

        if (!isLinkedProduct) {
          let colorList = qvScopeForInit.querySelectorAll('li[data-colorcheck="color"]')
          colorList = [...colorList].map((val) => val.dataset.colorvalue)

          for (let i = 0; i < colorList.length; i++) {
            let color = colorList[i].replace(/-/g, '')
            let soldOut = true
            for (option in memory) {
              if (option.split('-').join('').toLowerCase().includes(color)) {
                if (memory[option].availability == true) {
                  soldOut = false
                }
              }
            }
            if (soldOut) {
              let soldOutColor = qvScopeForInit.querySelector(`li[data-colorvalue=${colorList[i]}]`)
              if (soldOutColor) {
                soldOutColor.classList.add('soldOut')
              }
            }
          }
        }

        // Add event listeners to all options
        clickableOptions.forEach(function (option) {
          option.addEventListener('click', function (e) {
            const clickedOption = e.currentTarget

            if (clickedOption.classList.contains('disabled')) return

            const optionRow = clickedOption.dataset.optionIndex
            const optionValue = clickedOption.dataset.value

            const updatedState = pData.actions.selectOption(optionRow, optionValue, selectedOptions, memory)
            const newMemory = updatedState.memory
            const newSelectedOptions = updatedState.selectedOptions
            const detailsButton = qvScopeForInit.querySelector('[data-details-link]')
            const newSelectedOptionsKey = Object.values(newSelectedOptions).join('').replace(/\s/g, '')
            const selectedVariantId = newMemory[newSelectedOptionsKey]?.id

            // update state
            selectedOptions = newSelectedOptions
            memory = newMemory

            const colorCheck = clickedOption.dataset.colorcheck

            //update color display
            if (colorCheck === 'color') {
              if (colorDisplay) colorDisplay.innerText = optionValue
              //update details button url on color change
              if (detailsButton) {
                let variantURL = new URL(detailsButton.href)
                variantURL.searchParams.set('variant', selectedVariantId)
                detailsButton.href = variantURL.href
              }
            }
          })
        })

        // After click handlers are attached, trigger selectOption for the first option (color)
        // to properly initialize the disabled/enabled states for dependent options (sizes).
        // This ensures sizes are selectable on first load without requiring a color click.
        // This is especially important for products with only one color.
        if (selectedOptions['1']) {
          const initState = pData.actions.selectOption('1', selectedOptions['1'], selectedOptions, memory)
          selectedOptions = initState.selectedOptions
          memory = initState.memory
        }
      }

      const urlVar = url.includes('variant=') ? url.split('variant=')[1].split('&')[0] : null
      if (urlVar) {
        pData.actions.selectVariant(urlVar)
      }

      document.body.addEventListener('click', (event) => {
        if (event.target.matches('div[data-option="Coverage"] .nav-item.active')) {
          pData.actions.showAvailableColors()
        }
      })

      pData.actions.showAvailableColors()
      addOptionClickListeners()
    }
  }

  pData.init()
}

// Listen for product data changes from linked products
document.addEventListener('quickview:product-changed', function (event) {
  if (event.detail && event.detail.productData) {
    // Re-initialize with new product data
    // Use empty URL to avoid selecting a stale variant from main PDP URL
    // The setupData will find the first in-stock variant from the new product
    setupData('', event.detail.productData)
  }
})

function createVariantMemory() {
  const modalBody = document.querySelector('#modal-body-content')
  const quickViewModal = document.querySelector('#quick-view')
  const scope = quickViewModal || modalBody || document
  const scriptTag =
    scope.querySelector('script[type="application/json"][data-product-js]') ||
    document.querySelector('script[type="application/json"][data-product-js]')
  if (!scriptTag) return {}
  const productData = JSON.parse(scriptTag.textContent)

  const memory = {}

  productData.config.product.variants.forEach((variant) => {
    const options = [variant.option1, variant.option2, variant.option3].filter(Boolean).map((option) => option.replace(/\s/g, ''))
    memory[options.join('')] = { availability: variant.available, id: variant.id }
  })

  return memory
}

function getSelectedKey(selectedOptions) {
  return [selectedOptions['1'], selectedOptions['2'], selectedOptions['3']].filter(Boolean).join('').replace(/\s/g, '')
}

function updateActiveOptions(variant, scope = document) {
  ;['option1', 'option2', 'option3'].forEach((optionKey, index) => {
    const optionValue = variant[optionKey]
    const optionIndex = (index + 1).toString() // Convert to "1", "2", "3"
    if (optionValue) {
      scope.querySelectorAll(`li[data-option-index="${optionIndex}"]`).forEach((el) => {
        el.classList.remove('active')
        el.classList.add('not-active')
        const navLink = el.querySelector('.nav-link')
        if (navLink) {
          navLink.classList.remove('active')
          navLink.classList.add('not-active')
        }
      })
      scope.querySelectorAll(`li[data-option-index="${optionIndex}"][data-value="${optionValue}"]`).forEach((el) => {
        el.classList.remove('not-active')
        el.classList.add('active')
        const navLink = el.querySelector('.nav-link')
        if (navLink) {
          navLink.classList.remove('not-active')
          navLink.classList.add('active')
        }
      })
    }
  })
}

function updateProductPrice(variant, scope = document) {
  const productPriceElement = scope.querySelector('#productPrice')
  if (productPriceElement) {
    const formatP = (cents) => {
      const val = (cents / 100).toFixed(2)
      return val.endsWith('.00') ? (cents / 100).toFixed(0) : val
    }

    const tagDiscountPercent = quickViewProductData?.config?.tagDiscountPercent || 0
    const hasTagDiscount = tagDiscountPercent > 0
    const hasComparePrice = variant.compare_at_price && variant.compare_at_price > 0 && variant.compare_at_price > variant.price

    if (hasTagDiscount) {
      const discounted = variant.price - (variant.price * tagDiscountPercent)
      productPriceElement.innerHTML = `
        <span class="productPrice__compare" id="comparePrice" data-compare-price>$${formatP(variant.price)}</span>
        <span class="productPrice__price" data-product-price>$${formatP(discounted)}</span>
      `
    } else if (hasComparePrice) {
      productPriceElement.innerHTML = `
        <span class="productPrice__compare" id="comparePrice" data-compare-price>$${formatP(variant.compare_at_price)}</span>
        <span class="productPrice__price" data-product-price>$${formatP(variant.price)}</span>
      `
    } else {
      productPriceElement.innerHTML = `
        <span class="productPrice__price" data-product-price>$${formatP(variant.price)}</span>
      `
    }
  }
}
